import React from 'react';
import { TextInput, NumberInput, NumberSelector, DropdownSelector } from 'hyperdb-utils';

const FeaturesTab = ({ objectData, onChange }) => {
  const handleChangenbBeds = (attributeName, field) => {
    const beds = (objectData.beds || {});
    beds[attributeName] = field.value ? parseInt(field.value) : 0;
    onChange('beds', { value: beds });
  };

  return (
    <fieldset>
      <DropdownSelector
        label="Type *"
        name="type"
        value={ objectData.type || '' }
        options={ typesOptions() }
        onChange={ onChange.bind(null, 'type') }
      />
      <TextInput
        label="License number"
        name="license_number"
        value={ objectData.license_number }
        onChange={ onChange.bind(null, 'license_number') }
      />
      <NumberInput
        label="Surface (m2) *"
        name="surface"
        value={ objectData.surface }
        onChange={ onChange.bind(null, 'surface') }
      />
      <NumberSelector
        label="Standard Capacity *"
        name="standard_capacity"
        min={ 1 }
        max={ 30 }
        value={ objectData.standard_capacity }
        onChange={ onChange.bind(null, 'standard_capacity') }
      />
      <NumberSelector
        label="Maximum Capacity *"
        name="maximum_capacity"
        min={ 1 }
        max={ 30 }
        value={ objectData.maximum_capacity }
        onChange={ onChange.bind(null, 'maximum_capacity') }
      />
      <NumberSelector
        label="Nb bedrooms *"
        name="nb_bedrooms"
        min={ 0 }
        max={ 30 }
        value={ objectData.nb_bedrooms }
        onChange={ onChange.bind(null, 'nb_bedrooms') }
      />
      <NumberSelector
        label="Nb bathrooms *"
        name="nb_bathrooms"
        min={ 0 }
        max={ 30 }
        value={ objectData.nb_bathrooms }
        onChange={ onChange.bind(null, 'nb_bathrooms') }
      />
      <NumberSelector
        label="Nb toilets (separate from bathrooms)"
        name="nb_toilets"
        min={ 0 }
        max={ 30 }
        value={ objectData.nb_toilets }
        onChange={ onChange.bind(null, 'nb_toilets') }
      />
      <DropdownSelector
        label="Kitchen type"
        name="kitchen_type"
        placeholder="none"
        options={ kitchenTypeOptions() }
        value={ objectData.kitchen_type }
        onChange={ onChange.bind(null, 'kitchen_type') }
      />
      <NumberInput
        label="Floor *"
        name="floor"
        value={ objectData.floor }
        onChange={ onChange.bind(null, 'floor') }
      />
      <NumberInput
        label="Nb floors"
        name="nb_floors_building"
        value={ objectData.nb_floors_building }
        onChange={ onChange.bind(null, 'nb_floors_building') }
      />
      <NumberInput
        label="Surface of the land (m2)"
        name="land_surface"
        value={ objectData.land_surface }
        onChange={ onChange.bind(null, 'land_surface') }
      />
      <DropdownSelector
        label="Furniture *"
        name="furniture"
        value={ objectData.furniture || '' }
        options={ furnituresOptions() }
        onChange={ onChange.bind(null, 'furniture') }
      />
      <fieldset>
        <legend>Beds</legend>
        <NumberSelector
          label="Nb double beds"
          name="nb_double_beds"
          min={ 0 }
          max={ 30 }
          value={ (objectData.beds || {}).nb_double_beds }
          onChange={ handleChangenbBeds.bind(null, 'nb_double_beds') }
        />
        <NumberSelector
          label="Nb single beds"
          name="nb_single_beds"
          min={ 0 }
          max={ 30 }
          value={ (objectData.beds || {}).nb_single_beds }
          onChange={ handleChangenbBeds.bind(null, 'nb_single_beds') }
        />
        <NumberSelector
          label="Nb sofa beds"
          name="nb_sofa_beds"
          min={ 0 }
          max={ 30 }
          value={ (objectData.beds || {}).nb_sofa_beds }
          onChange={ handleChangenbBeds.bind(null, 'nb_sofa_beds') }
        />
        <DropdownSelector
          label="Baby cot"
          name="baby_cot"
          placeholder="none"
          value={ objectData.baby_cot }
          options={ babyCotOptions() }
          onChange={ onChange.bind(null, 'baby_cot') }
        />
      </fieldset>
    </fieldset>
  );
};

function typesOptions() {
  return ['house', 'villa', 'apartment', 'room', 'bingalow', 'mobil-home', 'castle', 'shop', 'office', 'warehouse', 'other' ].map(t => {
    return { name: t, value: t };
  });
}
function furnituresOptions() {
  return [
    { name: 'unfurnished', value: 0 },
    { name: 'semi-furnished', value: 1 },
    { name: 'full-furnished', value: 2 },
  ];
}
function kitchenTypeOptions() {
  return [
    { name: 'separate kitchen', value: 'separate_kitchen' },
    { name: 'kitchen opening to living room', value: 'kitchen_open_living_room' },
    { name: 'kitchen corner in living room', value: 'kitchen_corner_living_room' },
  ];
}
function babyCotOptions() {
  return [
    { name: 'included', value: 'included' },
    { name: 'on request (free)', value: 'on_request_free' },
    { name: 'on request (paid)', value: 'on_request_paid' },
  ];
}

export default FeaturesTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/PropertyEditor/FeaturesTab.jsx